import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals.js';
import './bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import AppRoutes from "./routes/AppRoutes.js";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <AppRoutes/>
);

reportWebVitals();
